import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit {
  
  // Tab management
  activeTab: string = 'list';
  user: any;

  // Tab configuration
  tabs = [
    {
      id: 'list',
      label: 'Lista de Transferencias',
      icon: 'nc-icon nc-bullet-list-67',
      roles: [1, 2, 3, 6],
      description: 'Ver y gestionar todas las transferencias'
    },
    {
      id: 'reports',
      label: 'Reportes',
      icon: 'nc-icon nc-chart-bar-32',
      roles: [1, 2, 3],
      description: 'Reportes de inventario y actividad'
    },
    {
      id: 'config',
      label: 'Configuración',
      icon: 'nc-icon nc-settings',
      roles: [1, 2, 3],
      description: 'Gestión de tipos de contenedor'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    // Initialize with list tab
    this.user = JSON.parse(localStorage.getItem('user'));
    console.log(this.user);
    
    this.activeTab = 'list';
  }

  /**
   * Switch to a specific tab
   * @param tabId - The ID of the tab to activate
   */
  switchTab(tabId: string): void {
    this.activeTab = tabId;
  }

  /**
   * Check if a tab is currently active
   * @param tabId - The ID of the tab to check
   * @returns true if the tab is active
   */
  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }

}
